import { Component, OnInit } from '@angular/core';
import { AuthService } from '../core/services/auth.service';
import { SessionLockService } from '../core/services/session-lock.service';

/**
 * Overlay přes celou aplikaci, který se zobrazí když je relace zamčená
 * (SessionLockService). E-mail je předvyplněný a jen ke čtení — uživatel zadá
 * jen heslo a rychle se vrátí přesně tam, kde byl (po odemčení se stránka
 * znovu načte s platným tokenem). Alternativně se může přihlásit jako jiný
 * uživatel (tvrdé odhlášení).
 */
@Component({
  selector: 'app-lock-screen',
  templateUrl: './lock-screen.component.html',
  styleUrls: ['./lock-screen.component.scss']
})
export class LockScreenComponent implements OnInit {
  visible = false;
  email = '';
  password = '';
  loading = false;
  errorMsg = '';

  constructor(private auth: AuthService, private lock: SessionLockService) {}

  ngOnInit(): void {
    this.lock.locked$.subscribe(locked => {
      this.visible = locked;
      if (locked) {
        // Předvyplň e-mail z aktuálně načteného uživatele, jinak z posledního přihlášení.
        this.email = this.auth.currentUser?.email ?? this.auth.lastEmail ?? '';
        this.password = '';
        this.errorMsg = '';
      }
    });
  }

  unlock(): void {
    if (!this.password || this.loading) {
      return;
    }
    this.loading = true;
    this.errorMsg = '';
    this.auth.login(this.email, this.password).subscribe({
      next: user => {
        this.loading = false;
        if (user) {
          this.lock.unlock();
          // Znovu načti aktuální stránku s platným tokenem — data, která během
          // zamčení selhala, se dotáhnou a uživatel zůstane na stejné URL.
          window.location.reload();
        } else {
          this.errorMsg = 'Přihlášení se nezdařilo. Zkuste to znovu.';
        }
      },
      error: () => {
        this.loading = false;
        this.errorMsg = 'Nesprávné heslo nebo relace vypršela.';
      }
    });
  }

  /** Přihlásit se jako jiný uživatel / úplné odhlášení. */
  logoutFull(): void {
    this.lock.unlock();
    this.auth.logout();
  }
}
